export default "__VITE_ASSET__c4180bd1__"